import { Component, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import Quill from 'quill';

@Component({
    selector: 'app-quill-non-editor',
    templateUrl: './quill-non-editor.component.html',
    styleUrls: ['./quill-non-editor.component.css'],
    standalone: false
})
export class QuillNonEditorComponent implements AfterViewInit {
  @ViewChild('editorContainer') editorContainer!: ElementRef;
  @Input() initialValue: string = '';  // Accepts only an initial value

  editor: Quill | undefined;

  ngAfterViewInit(): void {
    // Initialize Quill editor in readonly mode
    this.editor = new Quill(this.editorContainer.nativeElement, {
      theme: "snow",
      readOnly: true, // Makes it non-editable
      modules: {
        toolbar: false // Hides the toolbar
      }
    });

    // Set the initial value
    if (this.editor) {
      this.editor.root.innerHTML = this.initialValue;
    }
  }
}
